@if (open()) {
  <div class="fixed inset-0 z-50 bg-brand-cream flex flex-col">
    <app-popup-close (closed)="close()" />
    <div class="flex flex-col items-center justify-center flex-1 p-8 text-black">
      <h1 class="font-display font-bold uppercase text-4xl mb-8">Book it</h1>
      <p class="text-lg text-center max-w-md mb-6">
        Reach out to book HIGH HEAT for your venue or event.
      </p>
      <div class="flex flex-col items-center gap-4">
        <button (click)="copyEmail()" class="hh-btn text-lg">
          {{ emailCopied() ? 'Copied!' : 'booking@highheatrocks.com' }}
        </button>
        <a href="https://drive.google.com/drive/folders/1FbLEEIBxyKN_k0kKLutIfbhl0v0_VnWx?usp=sharing" target="_blank" rel="noopener noreferrer" class="hh-btn text-lg">View EPK</a>
      </div>
    </div>
  </div>
}
